module.exports = __webpack_public_path__ + "static/works-003-f053fb0cb4e8a5ac47594ea4f5a53c16.jpg";